import React from 'react';
import styles from './list-item.module.scss';

interface Props {
  children: React.ReactNode;
  onClick: () => void;
  buttonData?: string;
  closeMenu?: () => void;
}

const ActionButton = ({onClick, children, buttonData, closeMenu}: Props) => {
  const handleClick = () => {
    if (closeMenu) {
      closeMenu();
    }
    onClick();
  };

  return (
    <li>
      <button
        className={styles.listItem}
        data-segment-track={buttonData ? 'button' : null}
        data-button-name={buttonData ? buttonData : null}
        onClick={handleClick}
      >
        {children}
      </button>
    </li>
  );
};

export default ActionButton;
